// src/components/flux/FluxNode.jsx
import React from 'react';
import './FluxNode.css';

const FluxNode = ({ id, type, name, position, data, isSelected, onDragStart, onDelete }) => {
  // Función para renderizar el icono según el tipo de nodo
  const renderIcon = () => {
    switch (type) {
      case 'trigger':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polygon points="10 8 16 12 10 16 10 8" />
          </svg>
        );
      case 'process':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        );
      case 'decision':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 22 12 12 22 2 12 12 2" />
            <path d="M12 18v-6" />
            <path d="M12 8v.01" />
          </svg>
        );
      case 'action':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
          </svg>
        );
      case 'output':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 10 4 15 9 20" />
            <path d="M20 4v7a4 4 0 0 1-4 4H4" />
          </svg>
        );
      default:
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        );
    }
  };

  // Obtener la clase CSS para el tipo de nodo
  const getNodeTypeClass = () => {
    return `node-${type}`;
  };

  return (
    <div 
      className={`flux-node ${getNodeTypeClass()} ${isSelected ? 'selected' : ''}`}
      style={{ 
        left: `${position.x}px`, 
        top: `${position.y}px` 
      }}
      onMouseDown={onDragStart}
    >
      <div className="node-header">
        <div className="node-icon">
          {renderIcon()}
        </div>
        <div className="node-title">{name}</div>
        {isSelected && (
          <button className="node-delete-btn" onClick={onDelete}>
            &times;
          </button>
        )}
      </div>
      <div className="node-content">
        {/* Mostrar información relevante basada en data */}
        {type === 'trigger' && data.provider && (
          <div className="node-info">Proveedor: {data.provider}</div>
        )}
        {type === 'process' && data.actions && (
          <div className="node-info">Acciones: {data.actions.length}</div>
        )}
        {type === 'decision' && data.conditions && (
          <div className="node-info">Condiciones: {data.conditions.length}</div>
        )}
        {type === 'action' && data.provider && (
          <div className="node-info">Servicio: {data.service}</div>
        )}
        {type === 'output' && data.provider && (
          <div className="node-info">Salida: {data.provider}</div>
        )}
      </div>
      
      {/* Puntos de conexión */}
      <div className="connection-point input-point"></div>
      <div className="connection-point output-point"></div>
    </div>
  );
};

export default FluxNode;